<template>
  <span class="mobile-overlay" :class="{'show': overlayVisible}"></span>
  <div class="image-box" :class="{'loaded': coverLoaded}">
    <img src="./../assets/images/profile/cover.jpg" alt="Eine Frau steht in einem großen Raum" @load="coverLoaded = true" ref="image">
    <span class="overlay" ref="imageOverlay"></span>
  </div>
  <div class="intro">
    <div class="text-wrapper">
      <div class="headline" ref="headline">
        <h1>Wofür wir stehen.</h1>
      </div>
      <div class="text-box">
        <h2>Unsere Werte</h2>
        <p>Kundenorientierung, Innovation, Verlässlichkeit und Nachhaltigkeit bestimmen unser Handeln.</p>
      </div>
      <div class="text-box">
        <h2>Unsere Vision</h2>
        <p>Für unsere Kundinnen und Kunden sind wir die treibende Kraft der digitalen Energiewelt von morgen.</p>
      </div>
      <div class="text-box">
        <h2>Unsere Mission</h2>
        <p>Die Begeisterung und der Erfolg unserer Kundinnen und Kunden sind unser Erfolg.</p>
      </div>
      <span class="overlay" ref="textOverlay"></span>
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  gsap.registerPlugin(ScrollTrigger);

  export default {
    name: "ProfileCover",
    data() {
      return {
        coverLoaded: false,
        progressOpacity: 1,
        overlayVisible: false
      }
    },
    watch: {
      progressOpacity() {
        this.$emit('cover-change', {progressOpacity: this.progressOpacity});
      }
    },
    emits: ['cover-change'],
    mounted() {
      const t = this;
      const imageOverlay = this.$refs.imageOverlay;
      const textOverlay = this.$refs.textOverlay;
      const headline = this.$refs.headline;

      gsap.to(imageOverlay,{
        opacity: 1,
        scrollTrigger: {
          trigger: imageOverlay,
          scrub: 0.2,
          scroller: '.content-wrapper',
          start: 'top 0',
          onUpdate: function (e) {
            const val = Math.round(e.progress * 100) / 100;
            t.overlayVisible = val > 0.6;
            textOverlay.style.opacity = val.toString();
            headline.style.opacity = (1 - val).toString();
            t.progressOpacity = val > 0.5 ? Math.round((2 - val * 2) * 100) / 100 : 1;
          }
        }
      });
    }
  }
</script>

<style scoped>
  .image-box {
    position: sticky;
    display: block;
    background-color: #102D61;
    height: calc(250px + 25vw);
    top: calc(-146px + -25vw);
    z-index: 2;
    overflow: hidden;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #102D61;
    opacity: 0;
  }
  .intro {
    position: relative;
    z-index: 2;
  }
  img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    object-fit: cover;
    transition: opacity 0.4s ease-out;
  }
  .loaded img {
    position: relative;
    display: block;
    opacity: 1;
  }
  .loaded + .intro .headline {
    opacity: 1;
  }
  .text-wrapper {
    width: 1200px;
    max-width: 90vw;
    display: flex;
    margin: 0 auto;
    transform: translate(0, -50%);
    background-image: url(../assets/images/profile-text-bg.jpg);
    background-size: cover;
    padding: 40px 20px;
    min-height: 226px;
  }
  .text-wrapper:before {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(177, 217, 149, 0.9) 0%, rgba(58, 186, 186, 0.9) 100%);
  }
  .headline {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    opacity: 0;
    transition: opacity 0.4s ease-out;
  }
  h1 {
    position: relative;
    display: block;
    font-size: 100px;
    font-weight: 700;
    text-align: center;
    margin: 0.2em;
    z-index: 1;
    background: linear-gradient(90.02deg, #B1D995 1.4%, #3ABABA 90.79%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .headline:before {
    content: "";
    position: absolute;
    top: 20%;
    left: 20%;
    right: 20%;
    bottom: 20%;
    border-radius: 50%;
    background-color: black;
    z-index: -1;
    filter: blur(30px);
    opacity: 0.5;
  }
  h2, p {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .text-box {
    position: relative;
    display: block;
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
    color: #102D61;
    padding: 0 40px;
  }
  .text-box + .text-box {
    border-left: 3px solid #102D61;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .text-wrapper {
      min-height: 180px;
      width: 1000px;
      padding: 30px 15px;
      position: relative;
    }
    h1 {
      font-size: 75px;
    }
    .image-box {
      top: calc(-173px + -25vw);
    }
  }
  @media(max-width: 999px) {
    .text-wrapper {
      min-height: 160px;
      width: 1000px;
      padding: 20px 10px;
      max-width: calc(100% - 68px);
    }
    .text-box {
      padding: 0 15px;
    }
    h1 {
      font-size: 60px;
    }
    .image-box {
      height: 70vw;
      top: calc(84px - 70vw);
    }
  }
  @media(max-width: 767px) {
    .image-box {
      height: 60vw;
      top: calc(64px - 60vw);
    }
    .mobile-overlay {
      position: sticky;
      top: 0;
      display: block;
      height: 0;
      box-shadow: 0 0 0 64px #102D61;
      z-index: 2;
      opacity: 0;
      transition: 0.2s ease;
    }
    .mobile-overlay.show {
      opacity: 1;
    }
    .text-wrapper {
      max-width: calc(100% - 20px);
    }
    p {
      font-size: 14px;
    }
  }
  @media(max-width: 567px) {
    .image-box {
      height: 100vw;
      top: calc(64px - 100vw);
    }
    .image-box {
      height: 100vw;
      top: calc(64px - 100vw);
    }
    h1 {
      line-height: 1;
      font-size: 16vw;
      margin-bottom: 20px;
    }
    .text-wrapper {
      max-width: calc(100% - 30px);
      padding: 5px 20px;
      display: block;
      transform: none;
      margin-top: -50px;
    }
    .text-wrapper .overlay {
      visibility: hidden;
    }
    .text-box {
      padding: 5px 0;
      max-width: none;
    }
    .text-box + .text-box {
      border-left: 0;
      border-top: 2px solid #102D61;
    }

  }
</style>